import React from "react";

import "../styles/TransactionSuccessModal.css";

import {
  CheckCircle2,
  Printer,
  X,
} from "lucide-react";

const TransactionSuccessModal = ({
  transaction,
  onClose,
}) => {
  if (!transaction) return null;

  const handlePrintReceipt = () => {
    const receiptWindow = window.open(
      "",
      "_blank",
      "width=400,height=900"
    );

    receiptWindow.document.write(`
      <html>

        <head>

          <title>
            Finance Receipt
          </title>

          <style>

            @page{
              size:80mm auto;
              margin:0;
            }

            body{
              margin:0;
              padding:0;

              background:white;

              font-family:Arial,sans-serif;

              width:80mm;

              color:#071133;
            }

            .receipt{
              width:72mm;

              margin:auto;

              padding:4mm;

              box-sizing:border-box;
            }

            .center{
              text-align:center;
            }

            .logo{
              font-size:20px;
              font-weight:900;

              line-height:1.2;

              margin-bottom:2mm;
            }

            .sub{
              color:#14b8a6;

              font-size:13px;
              font-weight:700;

              margin-bottom:4mm;
            }

            .divider{
              border-top:1px dashed #94a3b8;

              margin:3mm 0;
            }

            .section{
              margin-top:3mm;
            }

            .row{
              display:flex;

              justify-content:space-between;

              align-items:flex-start;

              gap:8px;

              margin-bottom:2.5mm;

              font-size:12px;

              line-height:1.4;
            }

            .label{
              width:42%;

              font-weight:700;
            }

            .value{
              width:58%;

              text-align:right;

              word-break:break-word;
            }

            .highlight{
              color:#14b8a6;

              font-weight:800;
            }

            .footer{
              text-align:center;

              margin-top:6mm;

              font-size:11px;

              line-height:1.7;

              color:#475569;
            }

            .thankyou{
              font-size:13px;

              font-weight:900;

              margin-top:2mm;

              color:#071133;
            }

          </style>

        </head>

        <body>

          <div class="receipt">

            <div class="center">

              <div class="logo">
                RCS TOPUP & BILLING ENTITY
              </div>

              <div class="sub">
                FOCUS FINANCE
              </div>

            </div>

            <div class="divider"></div>

            <div class="section">

              <div class="row">
                <div class="label">
                  CLIENT ID
                </div>

                <div class="value">
                  ${transaction.investorId}
                </div>
              </div>

              <div class="row">
                <div class="label">
                  CLIENT NAME
                </div>

                <div class="value">
                  ${transaction.investorName}
                </div>
              </div>

              <div class="row">
                <div class="label">
                  TRANSACTION
                </div>

                <div class="value">
                  ${transaction.transactionType}
                </div>
              </div>

              <div class="row">
                <div class="label">
                  DATE & TIME
                </div>

                <div class="value">
                  ${new Date(
                    transaction.transactionDate
                  ).toLocaleString()}
                </div>
              </div>

            </div>

            <div class="divider"></div>

            <div class="section">

              <div class="row">
                <div class="label">
                  BALANCE BEFORE
                </div>

                <div class="value">
                  $${transaction.balanceBefore.toLocaleString()}
                </div>
              </div>

              <div class="row">
                <div class="label">
                  TRANSACTION AMOUNT
                </div>

                <div class="value highlight">
                  $${transaction.amount.toLocaleString()}
                </div>
              </div>

              <div class="row">
                <div class="label">
                  BALANCE AFTER
                </div>

                <div class="value">
                  $${transaction.balanceAfter.toLocaleString()}
                </div>
              </div>

              <div class="row">
                <div class="label">
                  AVAILABLE BALANCE
                </div>

                <div class="value">
                  $${transaction.availableBalance.toLocaleString()}
                </div>
              </div>

              <div class="row">
                <div class="label">
                  CURRENT BALANCE
                </div>

                <div class="value">
                  $${transaction.currentBalance.toLocaleString()}
                </div>
              </div>

            </div>

            <div class="divider"></div>

            <div class="footer">

              THANK YOU FOR CHOOSING

              <div class="thankyou">
                RCS FOCUS FINANCE
              </div>

            </div>

          </div>

          <script>
            window.onload = () => {
              window.print();
            };
          </script>

        </body>

      </html>
    `);

    receiptWindow.document.close();
  };

  return (
    <div className="transaction-success-overlay">

      <div className="transaction-success-card">

        <div className="success-icon-wrapper">
          <CheckCircle2 size={90} />
        </div>

        <h1>
          Transaction Successful
        </h1>

        <p>
          Investor balances updated successfully.
        </p>

        <div className="success-actions">

          <button
            className="success-print-btn"
            onClick={handlePrintReceipt}
          >
            <Printer size={18} />

            Print Receipt
          </button>

          <button
            className="success-close-btn"
            onClick={onClose}
          >
            <X size={18} />

            Close
          </button>

        </div>

      </div>

    </div>
  );
};

export default TransactionSuccessModal;